@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" class="custom-loader"></mat-progress-bar>
  </div>
}

<div class="container-fluid mb-5">

  <div class="dashboard-card shadow-sm border-primary">

    <div class="card-header d-flex align-items-center">
      <mat-icon class="header-icon">{{ getIconByType() }}</mat-icon>
      <div>
        <h5 class="mb-0 font-weight-bold text-primary-purple">{{ question?.question }}</h5>
        @if (question?.typology) {
          <small class="text-muted">
            {{ question?.typology | titlecase }} Analysis
          </small>
        }
      </div>
    </div>

    <div class="card-body">

      @if (question?.description) {
        <div class="alert alert-info my-3 mx-3 d-flex align-items-start" role="alert">
          <mat-icon class="alert-info-icon flex-shrink-0 mr-2">info</mat-icon>
          <div>
            <strong>{{ 'generic.description' | translate }}:</strong> {{ question.description }}
          </div>
        </div>
      }

      @if (timelineIsDisabled) {
        <div class="container my-3">
          <p class="text-center text-muted">Timeline view disabled for this question type.</p>
        </div>
      } @else {
        <div class="chart-section">
          <div class="d-flex justify-content-between align-items-end mb-3">
            <div>
              <div class="box py-0 px-0 bg-transparent border-0 mb-0">
                <mat-label class="box-title p-0 mb-1">Trends</mat-label>
              </div>
              <div class="d-flex align-items-center">
                <mat-icon class="chart-section-icon">analytics</mat-icon>
                <span class="chart-section-title text-muted">Data Analysis</span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              @if (currentChartType === 'line') {
                <mat-button-toggle-group
                  [value]="isSmooth"
                  (change)="setSmooth($event.value)"
                  [hideMultipleSelectionIndicator]="true"
                  [hideSingleSelectionIndicator]="true"
                  class="custom-purple-toggle mr-3 shadow-sm">
                  <mat-button-toggle [value]="true" matTooltip="Smooth Lines">
                    <mat-icon>gesture</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle [value]="false" matTooltip="Straight Lines">
                    <mat-icon>linear_scale</mat-icon>
                  </mat-button-toggle>
                </mat-button-toggle-group>
                <div class="border-left h-100 mx-1" style="height: 36px; border-color: #e0e0e0;"></div>
              }
              <div class="d-flex flex-column align-items-end">
                <mat-button-toggle-group
                  name="chartType"
                  [value]="currentChartType"
                  (change)="setChartType($event.value)"
                  [hideMultipleSelectionIndicator]="true"
                  [hideSingleSelectionIndicator]="true"
                  class="custom-purple-toggle shadow-sm">
                  <mat-button-toggle value="line" matTooltip="Line Chart">
                    <mat-icon>show_chart</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle value="bar" matTooltip="Bar Chart">
                    <mat-icon>bar_chart</mat-icon>
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </div>
          </div>
          <div class="chart-container rounded p-1">
            <div
              echarts
              [options]="chartOptions"
              (chartClick)="onChartClick($event)"
              class="w-100 demo-chart"
              [style.height.px]="400">
            </div>
          </div>
        </div>
      }

      <!--
      <div class="mt-5 pt-4 border-top">
        <h6 class="text-uppercase text-muted letter-spacing-2 mb-3">History Flow</h6>
        <div #mermaid class="mermaid-container d-flex justify-content-center"></div>
      </div>-->

    </div>
  </div>
</div>
